import { render, staticRenderFns } from "./ViPhoneNumber.vue?vue&type=template&id=5d8f45bd&"
import script from "./ViPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ViPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./ViPhoneNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports